import {
    getCanonicalItemList,
    isCanonicalItemList
} from '../../upi/data-layer-constants';

export function getItemListFromElement ( element ) {
    if ( !element ) {
        return null;
    }

    return getCanonicalItemList(
        element.getAttribute( 'data-item-list-id' ),
        element.getAttribute( 'data-item-list-name' )
    );
}

export function withItemListAttribution ( lineItem, itemList ) {
    if ( !isCanonicalItemList( itemList ) ) {
        return lineItem;
    }

    return {
        ...lineItem,
        itemList
    };
}
